import type { FormElement, HeaderProperties } from '../../model/form.types';
import { DEFAULT_HEADER_MAIN_LABEL, DEFAULT_HEADER_MARGIN } from '../../model/header-defaults';
import type { HeaderDefinition } from '../../model/types';

type HeaderElement = FormElement & { properties: HeaderProperties };

// The header keeps one margin per page; the fill view renders a single flow, so the first
// page's margin is the one that applies.
function firstPageMargin(element: HeaderElement) {
  const margin = element.properties.marginByPage?.[0] ?? element.properties.margin ?? DEFAULT_HEADER_MARGIN;
  return {
    top: margin.top ?? 0,
    right: margin.right ?? 0,
    bottom: margin.bottom ?? 0,
    left: margin.left ?? 0,
  };
}

export const headerDefinition: HeaderDefinition<HeaderElement> = {
  kind: 'header',
  type: 'HEADER',
  compile: (element) => ({
    kind: 'header',
    id: element.id,
    type: 'HEADER',
    mainLabel: element.properties.mainLabel ?? DEFAULT_HEADER_MAIN_LABEL,
    rq: element.properties.rq ?? '',
    rev: element.properties.rev ?? '',
    title: (element.properties.title ?? '').trim(),
    margin: firstPageMargin(element),
  }),
};
